<template>
  <div class="px-4 py-2 border border-gray-300 rounded">
    <div class="flex justify-between">
      <div>
        <div
          class="text-lg"
          :class="{
            'text-gray-500': isCancelled
          }"
        >
          <svg
            v-if="isRestricted"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            style="display: inline"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              class="text-red-500"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>{{ productName }}</span>
        </div>
        <div class="text-gray-500">
          {{ variant.variant_name }} ({{ variant.id }})
        </div>
      </div>
      <div class="flex flex-col justify-center">
        <span
          v-if="isShipped"
          class="px-2 bg-green-500 text-xs text-white rounded-full"
        >
          Shipped {{ this.dateFormat(product.DateShipped) }}
        </span>
        <div
          v-else-if="!isCancelled"
          class="flex justify-around items-center space-x-2"
        >
          <button
            v-on:click="decrement()"
            :disabled="!canDecrement"
            class="p-1 bg-green-500 disabled:bg-gray-300 text-white disabled:text-gray-500 rounded-lg"
          >
            <icon name="minus" class="w-6 h-6" />
          </button>
          <input
            v-model="newQuantity"
            disabled
            class="w-24 px-1 text-lg text-center border border-green-500 rounded"
          />
          <button
            v-on:click="increment()"
            :disabled="!canIncrement"
            class="p-1 bg-green-500 disabled:bg-gray-300 text-white disabled:text-gray-500 rounded-lg"
          >
            <icon name="plus" class="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderEditProduct",
  components: {},
  props: {
    product: {
      type: Object,
      required: true
    },
    shopifyLineItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      newQuantity: 0
    };
  },
  computed: {
    productName() {
      return this.variant?.product?.name;
    },
    variant() {
      return this.product?.variant;
    },
    isShipped() {
      if (this.product.DateShipped === null) {
        return false;
      }

      const today = new Date();
      const printTime = new Date(this.product.DateShipped);
      return today > printTime;
    },
    isRestricted() {
      return this.product.ApprovalStatus === "RESTRICTED";
    },
    isCancelled() {
      if (
        String(this.product?.Product)
          .toUpperCase()
          .includes("CANCELED")
      ) {
        return true;
      }

      return Boolean(Number(this.product?.Canceled));
    },
    adjustableQuantity() {
      if (this.isCancelled) {
        return 0;
      }

      if (
        Number(this.product?.QuantityOrdered) <
        Number(this.shopifyLineItem?.refundableQuantity)
      ) {
        return Number(this.product?.QuantityOrdered);
      }

      return Number(this.shopifyLineItem?.refundableQuantity) || 0;
    },
    canIncrement() {
      if (this.isCancelled) {
        return false;
      }

      return Number(this.newQuantity) < this.adjustableQuantity;
    },
    canDecrement() {
      if (this.isCancelled) {
        return false;
      }

      return Number(this.newQuantity) > 0;
    }
  },
  created() {
    this.newQuantity = this.adjustableQuantity;
  },
  methods: {
    setRestricted() {
      this.product.restricted = true;
    },
    increment() {
      this.newQuantity++;
      this.$emit("quantity-updated", {
        ...this.product,
        adjustableQuantity: this.adjustableQuantity,
        NewQuantity: this.newQuantity
      });
    },
    decrement() {
      this.newQuantity--;
      this.$emit("quantity-updated", {
        ...this.product,
        adjustableQuantity: this.adjustableQuantity,
        NewQuantity: this.newQuantity
      });
    },
    dateFormat(dateString, options) {
      let date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        ...{ year: "numeric", month: "long", day: "numeric" },
        ...options
      });
    }
  }
};
</script>
